import { render, staticRenderFns } from "./Wheel.vue?vue&type=template&id=6475dda4&"
import script from "./Wheel.vue?vue&type=script&lang=js&"
export * from "./Wheel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports